export function resolvePageConfig(pageConfig) {
  if (pageConfig.prefetchApi) {
    Object.keys(pageConfig.prefetchApi).forEach((propKey) => {
      const config = pageConfig.prefetchApi[propKey]
      if (config.critical) {
        // 见下方注释说明
        throw new Error(
          '目前不支持业务页面将 prefetchApi 声明为关键任务，仅允许 global 声明关键任务'
        )
      }
    })
    if (process.dev) {
      if (pageConfig.prefetchApiFallback) {
        console.warn(
          '你使用了 prefetchApiFallback。留意，仅当部分条件下无需 fallback 时，才有实际加速意义。若任意条件下均需要 fallback，都无需定义此任务，使用IO或Redux管理即可。请仅对符合场景的请求，使用 PrefetchApi 机制，简化业务代码逻辑'
        )
      }
      if (pageConfig.prefetchApiCallback) {
        console.warn(
          '你使用了 prefetchApiCallback。请留意，如在 callback 中提供异步请求，其与 IO 发起请求在时序上没有差异。请仅对符合场景的请求，使用 PrefetchApi 机制，简化业务代码逻辑'
        )
      }
    }
  }
  return pageConfig
}
